import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import styles from "./ConfirmEmail.module.css";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";

import { StaticRoutes } from "../routes";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { AccountContainer } from "../../hooks/useAccount";
import environment from "../../environment";

const ConfirmEmail = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  pricingOptions = [
    {
      packageName: "BidPro Bundle",
      priceMonthly: "26.99",
      priceAnnual: "323.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Access to all the BidPro apps including:",
            features: [
              {
                feature: "Web-based Bidding",
                isNew: "",
              },
              {
                feature: "Seniority",
                isNew: "",
              },
              {
                feature: "Web-based TripBoard",
                isNew: "",
              },
              {
                feature: "iOS Mobile TripBoard",
                isNew: "NEW!*",
              },
            ],
          },
        },
      ],
      isBundle: true,
      savings: "10%",
      note: "Unlimited downloads for all your iOS devices included!",
    },
    {
      packageName: "Bidding & Seniority",
      priceMonthly: "9.99",
      priceAnnual: "119.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "Bidding",
            features: [
              {
                feature: "Download bid packages",
                isNew: "",
              },
              {
                feature: "Customize bidline colors & sorts",
                isNew: "",
              },
              {
                feature: "Search & prepare bids offline",
                isNew: "",
              },
              {
                feature: "Submit bids directly and skip PBSI",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "Seniority",
            features: [
              {
                feature: "View Seniority Ranking on a detailed graph",
                isNew: "",
              },
              {
                feature: "Compare rankings to other fleets",
                isNew: "",
              },
              {
                feature: "View yearly retires and estimate seniority",
                isNew: "",
              },
              {
                feature: "Use offline",
                isNew: "",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
    {
      packageName: "TripBoard",
      priceMonthly: "19.99",
      priceAnnual: "239.88",
      onMonthly: null,
      onAnnual: null,
      sections: [
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Web-based TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "View estimated pay & credit",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "",
            header: "IOS Mobile TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "Sync your schedule to your device",
                isNew: "NEW!",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const { emailToken } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("userId");
  const code = searchParams.get("code");

  const navigate = useNavigate();
  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  useEffect(() => {
    if (!userId || !code) {
      navigate("/", { replace: true }); // Redirect to homepage
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await fetch(
          `${environment.apiBase}/Account/ConfirmEmail?userId=${userId}&code=${code}`
        );

        if (response.ok) {
          const data = await response.json();
          setMessage(
            data.message || "Your email has been successfully verified!"
          );
        } else {
          const errorData = await response.json();
          setError(
            errorData.message || "Email verification failed. Please try again."
          );
        }
      } catch (err) {
        setError("An error occurred while verifying your email.");
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [userId, code, navigate]);

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      <div className={styles.pageContainer}>
        <div className="container text-center">
          {loading ? (
            <h2 className="mb-3 mt-4">Verifying Email...</h2>
          ) : (
            <>
              {error && (
                <div className={styles.customAlert} role="alert">
                  Email verification failed. Please try again.
                </div>
              )}
              <h3 className="mb-3 mt-4">
                {error ? "Error Verifying Email" : "Email Verified!"}
              </h3>
              <p>{error}</p>
            </>
          )}
          {!loading && !error && <p className="mb-3">{message}</p>}
        </div>
      </div>
      <Footer lists={footerLists} inverse={true} />
    </>
  );
};
ConfirmEmail.propTypes = {
  navList: PropTypes.array,
  pricingOptions: PropTypes.array,
  footerLists: PropTypes.array,
};

export default ConfirmEmail;
